import css from 'styled-jsx/css';

export const imageStyle = css`
object-fit:contain;
`;
